import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SelectorUtil} from "@app-web-central/web/shared/utils";
import {rolesFeatureKey, RolesState} from "./roles.reducer";

export const getRolesState = createFeatureSelector<RolesState>(rolesFeatureKey);

export const getRoles = createSelector(getRolesState, (state) => state.data);
export const getRolesLoading = createSelector(getRolesState, SelectorUtil.isLoading);
